import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    catchError,
    combineLatestWith,
    concatMap,
    delay,
    exhaustMap,
    of,
    switchMap,
} from 'rxjs';
import { BadResponseWithError } from '../../models/bad-response-with-error.interface';
import { MediaService } from '../../services/media.service';
import { NotificationsService } from '../../services/notifications.service';
import { UploadMediaActions } from '../action/actions-type.action';

@Injectable()
export class MediaEffect {
    uploadImage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UploadMediaActions.uploadImageFile),
            switchMap(({ payload }) =>
                this.mediaService
                    .requestRewardUploadToken({
                        domain: payload.domain,
                        mediaType: payload.mediaType,
                        targetId: payload.targetId,
                    })
                    .pipe(combineLatestWith(of(payload)))
            ),
            switchMap(([token, payload]) =>
                this.mediaService.uploadImage(payload, token).pipe(
                    delay(1000),
                    concatMap(() => {
                        // const sideEffects =[];
                        payload.onSuccess(payload);

                        return [
                            UploadMediaActions.uploadImageFileSuccess({
                                payload,
                                id: token.token,
                            }),
                            //   ...sideEffects,
                        ];
                    }),
                    catchError((response: BadResponseWithError) => {
                        this.notificationsService.showError(
                            response.error.message
                        );
                        return of(
                            UploadMediaActions.uploadImageFileFailure({
                                payload: response,
                            })
                        );
                    })
                )
            )
        )
    );

    removeImage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UploadMediaActions.removeImageFile),
            exhaustMap(({ payload }) =>
                this.mediaService.removeImageFile(payload).pipe(
                    delay(300),
                    concatMap(() => {
                        // const sideEffects = [];

                        return [
                            UploadMediaActions.removeImageFileSuccess(),
                            // ...sideEffects,
                        ];
                    }),
                    catchError((response: BadResponseWithError) => {
                        this.notificationsService.showError(
                            response.error.message
                        );
                        return of(
                            UploadMediaActions.removeImageFileFailure({
                                payload: response,
                            })
                        );
                    })
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private mediaService: MediaService,
        private notificationsService: NotificationsService
    ) {}
}
